import apiClient from '../utils/apiClient';

const API_BASE_URL = '/Flow'; // API_SERVER zaten apiClient içinde ayarlı

// Flow verisini backend'e POST ile gönderme
export const createFlow = async serviceSettingData => {
  try {
    const response = await apiClient.post(API_BASE_URL, serviceSettingData);
    return response.data;
  } catch (error) {
    console.error('Error in request:', error.response?.data?.message || error);
    throw new Error(
      error.response?.data?.message || 'Error creating service setting'
    );
  }
};

export const getFlowById = async id => {
  try {
    const response = await apiClient.get(`${API_BASE_URL}/?id=${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching flow by ID:', error);
    throw error;
  }
};

export const updateFlow = async (id, flowData) => {
  try {
    const response = await apiClient.put(`${API_BASE_URL}/?id=${id}`, flowData);
    return response.data;
  } catch (error) {
    console.error('Error updating flow:', error.response?.data || error);
    throw error;
  }
};

export const deleteFlow = async id => {
  try {
    const response = await apiClient.delete(`${API_BASE_URL}/?id=${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting flow:', error.response?.data || error);
    throw new Error(error.response?.data?.message || 'Error deleting flow');
  }
};

// Backend'den tüm flow verilerini alma
export const getAllFlows = async () => {
  try {
    const response = await apiClient.get(`${API_BASE_URL}/GetAll`);
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching flows:',
      error.response?.data?.message || error
    );
    throw new Error(error.response?.data?.message || 'Error fetching flows');
  }
};
